import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  close(event) {
    if (this.element.open && !this.element.contains(event.target)) {
      this.element.open = false;
    }
  }
}
